import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";

import { CHART_TAB } from "../../constant/common";
import { useCompanySettings, useSelectedInstrument } from "../../hooks/useCompanySettings";
import { useInstrument } from "../../hooks/useInstruments";
import { useAmountInvested, useColumnChartData, useLineChartData } from "../../hooks/useTrades";
import { instrumentDataAndSettingSelector } from "../../store/slice/trade";
import { getCurrencyLabel } from "../../store/utils";
import { classNames } from "../../utils";
import { HighChartControl } from "../HighChartControl";
import { HighChartMultipleLine } from "../HighCharts/HighChartMultipleLine";
import { HighChartsMultipleColumn } from "../HighCharts/HighChartsMultipleColumn";
import { TabPanel, TabPanels, Tabs } from "@euroland/react-tablist";
import { AmountInvestedTabContentContext } from "../../context/AmountAndShareSelectContext";

export default function AmountInvestedChart() {
  const [chart, setChart] = useState(CHART_TAB.SPLINE_CHART);
  const instrumentDataAndSetting = useSelector(instrumentDataAndSettingSelector);
  const { series } = useLineChartData();
  const { data, xAxisCategory, periodType, dividendData, sharePrice } = useColumnChartData();
  const settings = useCompanySettings();
  const [{ query }] = useAmountInvested();
  const [{ selectedInstrument }] = useInstrument();
  const currencyCode = getCurrencyLabel(query.currency || selectedInstrument.currencyCode);
  const [, { formatNumber }] = useSelectedInstrument();
  const { hidden } =useContext(AmountInvestedTabContentContext);

  return (
    <div className={classNames("amount-invested-chart", `instrument-${selectedInstrument.instrumentId}`)}>
      <Tabs activeTab={chart} onChangeTab={setChart}>
        <HighChartControl chart={chart} setChart={setChart} />
        {!hidden && <div className="amount-invested-chart-content">
          <TabPanels>
            <TabPanel forTab={CHART_TAB.SPLINE_CHART}>
              {chart === CHART_TAB.SPLINE_CHART && <HighChartMultipleLine
                currencyCode={currencyCode}
                series={series}
                instrumentDataAndSetting={instrumentDataAndSetting}
                formatNumber={formatNumber}
              />}
            </TabPanel>
            <TabPanel forTab={CHART_TAB.COLUMN_CHART}>
              {chart === CHART_TAB.COLUMN_CHART && <HighChartsMultipleColumn
                data={data}
                currencyCode={currencyCode}
                categories={xAxisCategory}
                settings={settings}
                periodType={periodType}
                dividendData={dividendData}
                sharePrice={sharePrice}
                formatNumber={formatNumber}
              />}
            </TabPanel>
          </TabPanels>
        </div>}
      </Tabs>
    </div>
  );
}
